"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LogoutError;
// eslint-disable-next-line no-unused-vars
function LogoutError(code, error_code, error_description) {
  var instance = new Error(error_code);
  instance.message = error_code;
  instance.code = code;
  instance.description = error_description;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, LogoutError);
  }
  return instance;
}
LogoutError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
if (Object.setPrototypeOf) {
  Object.setPrototypeOf(LogoutError, Error);
} else {
  LogoutError.__proto__ = Error;
}